import { ApiResponse } from '@/domain'
import {
  CreateOfferingAgePricingDto,
  Offering,
  OfferingAgePricing,
  OfferingDto,
  OfferingFilters,
  OfferingPrice,
  OfferingPriceDto,
  UpdateOfferingAgePricingDto,
} from '@/domain/offerings/offering'
import { backendApi } from '../backendApi'

export const offeringsApi = {
  getOfferings: (filters?: OfferingFilters) =>
    backendApi.get<ApiResponse<Offering[]>>('/api/v1/offerings', { params: filters }).then((res) => res.data.data),

  getOffering: (id: string, includePrices: boolean = false) =>
    backendApi.get<ApiResponse<Offering>>(`/api/v1/offerings/${id}`, { params: { includePrices } }).then((res) => res.data.data),

  createOffering: (offering: OfferingDto) =>
    backendApi.post<ApiResponse<Offering>>('/api/v1/offerings', offering).then((res) => res.data.data),

  updateOffering: (id: string, offering: OfferingDto) =>
    backendApi.put<ApiResponse<Offering>>(`/api/v1/offerings/${id}`, offering).then((res) => res.data.data),

  deleteOffering: (id: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/offerings/${id}`).then((res) => res.data.data),

  getPrices: (offeringId: string) =>
    backendApi.get<ApiResponse<OfferingPrice[]>>(`/api/v1/offerings/${offeringId}/prices`).then((res) => res.data.data),

  addPrice: (offeringId: string, price: OfferingPriceDto) =>
    backendApi.post<ApiResponse<OfferingPrice>>(`/api/v1/offerings/${offeringId}/prices`, price).then((res) => res.data.data),

  updatePrice: (offeringId: string, priceId: string, price: Partial<OfferingPrice>) =>
    backendApi.put<ApiResponse<OfferingPrice>>(`/api/v1/offerings/${offeringId}/prices/${priceId}`, price).then((res) => res.data.data),

  deletePrice: (offeringId: string, priceId: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/offerings/${offeringId}/prices/${priceId}`).then((res) => res.data.data),

  getPublicOfferings: () =>
    backendApi.get<ApiResponse<Offering[]>>('/api/v1/public/offerings').then((res) => res.data.data),

  getPublicOffering: (id: string) =>
    backendApi.get<ApiResponse<Offering>>(`/api/v1/public/offerings/${id}`).then((res) => res.data.data),

  getAgePricing: (offeringId: string) =>
    backendApi.get<ApiResponse<OfferingAgePricing>>(`/api/v1/offerings/${offeringId}/age-pricing`).then((res) => res.data.data),

  getAgePricingByPrice: (offeringId: string, priceId: string) =>
    backendApi.get<ApiResponse<OfferingAgePricing>>(`/api/v1/offerings/${offeringId}/prices/${priceId}/age-pricing`).then((res) => res.data.data),

  addAgePricing: (offeringId: string, priceId: string, data: CreateOfferingAgePricingDto) =>
    backendApi.post<ApiResponse<OfferingAgePricing>>(`/api/v1/offerings/${offeringId}/prices/${priceId}/age-pricing`, data).then((res) => res.data.data),

  updateAgePricing: (offeringId: string, priceId: string, data: UpdateOfferingAgePricingDto) =>
    backendApi.put<ApiResponse<OfferingAgePricing>>(`/api/v1/offerings/${offeringId}/prices/${priceId}/age-pricing`, data).then((res) => res.data.data),

  deleteAgePricing: (offeringId: string, priceId: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/offerings/${offeringId}/prices/${priceId}/age-pricing`).then((res) => res.data.data),
}
